module.exports = __webpack_public_path__ + "static/media/add.c09f04a2.png";